import { NumberWithUnitsFormatter } from '@ddt-web/data-service';
import { StringUtil } from '@ddt-web/generic-utils';

declare const Highcharts;

/**
 * DecumHistogramChartTooltip
 */
export class DecumHistogramChartTooltip {
	public static getFormatter(customData: CustomData, displayCurrency: string = '$'): Function {
		const formatter = new NumberWithUnitsFormatter('0', '-', true);

		return function (): string {
			let out = '';
			let setTooltipHeader = true;
			let setTooltipFooter = true;
			out += '<div class="decum-histogram-tooltip-container">';
			this.points?.forEach(point => {
				if (setTooltipHeader) {
					out += `<h4 class="custom-margin"><span class="bold">${StringUtil.escapeHtml(customData.headerText[0])}</span> ${StringUtil.escapeHtml(point.x)}</h4>
								<h4 class="bold custom-margin">${StringUtil.escapeHtml(customData.headerText[1])}
								<span class="pull-right">${StringUtil.escapeHtml(displayCurrency)}${StringUtil.escapeHtml(formatter.format(Number(point.total)))}</span>
								</h4>
								<div class="border-bottom"></div>`;
					setTooltipHeader = false;
				}

				const seriesColor = point.series.color;
				if (point.y > 0) {
					out += `<div class="decum-histogram-tooltip"><table>
						<tr>
						<span class="custom-width"><td colspan="2" style="width:75%;"><div class="portfolio-icon" style="background-color:
						${StringUtil.escapeHtml(seriesColor)};border-radius:0; width:10px; height:10px; display:inline-block; margin-right:2px;"></div>
						${StringUtil.escapeHtmlWithChartLineBreaks(StringUtil.splitSpaceLessStringForChart(point.point.series.name, 50, true))}
						</td>
						</span>
						<td style="text-align: right;">
						${StringUtil.escapeHtml(displayCurrency)}${StringUtil.escapeHtml(formatter.format(Number(point.y)))}
						</td>
						</tr>
					</table></div>`;
				}

			});
			this.points?.forEach(point => {
				if (setTooltipFooter) {
					const portWdRate = customData.portfolioWithdrawalRates[point.x - customData.minIndex].valueOf();
					const finalRate = Highcharts.numberFormat(portWdRate * 100, 1, '.', ',');
					const upperBoundIncome = formatter.format(Number(customData.upperBoundIncomes[point.x - customData.minIndex]));
					const lowerBoundIncome = formatter.format(Number(customData.lowerBoundIncomes[point.x - customData.minIndex]));
					const presentDayEquivalents = formatter.format(Number(customData.presentDayEquivalents[point.x - customData.minIndex]));
					out += `<div class="border-bottom"></div>`;
					if (+upperBoundIncome !== 0 && +lowerBoundIncome !== 0) {
						out += `<h4 class="custom-margin"><span class="bold">${StringUtil.escapeHtml(customData.footerText[0])}</span> ${StringUtil.escapeHtml(displayCurrency)}${StringUtil.escapeHtml(upperBoundIncome)} - ${StringUtil.escapeHtml(displayCurrency)}${StringUtil.escapeHtml(lowerBoundIncome)}</h4>`;
					}
					out += `<h4 class="custom-margin"><span class="bold">${StringUtil.escapeHtml(customData.footerText[1])}</span> ${StringUtil.escapeHtml(displayCurrency)}${StringUtil.escapeHtml(presentDayEquivalents)}</h4>
						<h4 class="custom-margin"><span class="bold">${StringUtil.escapeHtml(customData.footerText[2])}</span> ${StringUtil.escapeHtml(finalRate)}%</h4>`;
					setTooltipFooter = false;
				}
			});
			out += '</div>';
			return out;
		};
	}
}

export interface CustomData {
	minIndex?: number;
	upperBoundIncomes?: Array<number>;
	lowerBoundIncomes?: Array<number>;
	presentDayEquivalents?: Array<number>;
	portfolioWithdrawalRates?: Array<number>;
	headerText?: string[];
	footerText?: string[];
}
